// extracted by mini-css-extract-plugin
export var carrierNotice = "_ll-5";
export var carrierNoticePlaceholder = "_ll-6";
export var deliveryRow = "_ll-c";
export var fixedHeight = "_ll-4";
export var freightLogo = "_ll-b";
export var fullWidth = "_ll-3";
export var priceColumn = "_ll-7";
export var radioSelected = "_ll-9";
export var radioUnselected = "_ll-8";
export var selectedOption = "_ll-2";
export var selectedOptionContainer = "_ll-1";
export var selection = "_ll-0";
export var tallSkeletonText = "_ll-a";